export default __webpack_public_path__ + "static/media/placeholderAvatar.5a1bd0f5.webp";